import { render, staticRenderFns } from "./paper.vue?vue&type=template&id=e643343a&scoped=true"
import script from "./paper.vue?vue&type=script&lang=js"
export * from "./paper.vue?vue&type=script&lang=js"
import style0 from "./paper.vue?vue&type=style&index=0&id=e643343a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e643343a",
  null
  
)

export default component.exports